import { httpRequest } from '@/apis/request'

enum Apis {
  getAllColors = 'load_all_color',
}

export async function fetchAllColor() {
  return httpRequest.post(Apis.getAllColors)
}
